import __assign from 'core-js/modules/_object-assign.js';
Object.assign = Object.assign || __assign;

import svg4Everybody from 'svg4everybody';
import { disableAutoStart, startComponents } from '@gondel/core';
import { initMediaQueriesPlugin } from '@gondel/plugin-media-queries';
import '../../../utils/browser-detection/js/browser-detection';
import { initResizePlugin } from '../../../utils/gondel-resize/js/gondel-resize';
import 'tslib';
import 'promise-polyfill/src/polyfill';
import 'picturefill';
import 'what-input';

svg4Everybody();

/**
 * This function bootstraps our application
 */
export default async function bootstrapApplication() {
	const breakPoints = {
		xxsmall: 480,
		xsmall: 768,
		small: 992,
		medium: 1240,
		large: 1440,
		xlarge: 1920,
		xxlarge: Infinity,
	};

	initMediaQueriesPlugin({ breakPoints });
	initResizePlugin();

	// onetrust wrapper bootstrap switch
	const onetrustWraps = document.querySelectorAll('.js-o-onetrust-wrapper');
	if (onetrustWraps.length > 0) {
		// disable gondel auto start for default name space
		disableAutoStart();

		// start onetrustWraps first
		await startComponents(document.body, 't');
		await startComponents();
	} else {
		await startComponents();
	}

	return;
}
